import { useEffect, useRef } from 'react';
import logger from '@/logger';

const SubscriptionTemplate = ({ sub, unsub, listeners, socket, routes, from, onReconnect }) => {
	const onReconnectRef = useRef(onReconnect);

	useEffect(() => {
		const handleDisconnect = reason => {
			if (reason === 'transport close') {
				logger.info(`🚶‍♂️ ${from} Disconnected - unsubAndRemoveListeners 🚶‍♂️`, reason);
				unsubAndRemoveListeners();
			}
		};
		const handleConnect = () => {
			logger.info(`⚡️ ${from} Connected - subAndAddListeners ⚡️`);
			// clear out any existing listeners after a disconnect to avoid duplicate listeners
			removeListeners();
			subAndAddListeners();
			if (onReconnectRef.current) onReconnectRef.current();
		};

		socket.on('disconnect', handleDisconnect);
		socket.on('connect', handleConnect);
		subAndAddListeners();
		logger.info(`⚡️ ${from} Mounted ⚡️`);
		return () => {
			// left on the socket, these outlive the component and on the next reconnect
			// resubscribe with whatever eventID their closures froze at mount
			socket.off('disconnect', handleDisconnect);
			socket.off('connect', handleConnect);
			unsubAndRemoveListeners();
			logger.info(`🚶‍♂️ ${from} Unmounted 🚶‍♂️`);
		};
	}, []);

	useEffect(() => {
		onReconnectRef.current = onReconnect;
	}, [onReconnect]);

	const addListeners = () => {
		listeners.forEach(listener => listener());
	};

	const removeListeners = () => {
		routes.forEach(route => {
			socket.off(route);
		});
	};

	const subAndAddListeners = () => {
		sub();
		addListeners();
	};

	const unsubAndRemoveListeners = () => {
		unsub();
		removeListeners();
	};

	return null;
};

export default SubscriptionTemplate;
